import React from 'react';

const RulesList = ({ rules, onDelete, onEdit }) => {
  const getRuleTypeDescription = (rule) => {
    switch (rule.type) {
      case 'prompt':
        return `AI-based prompt using ${rule.model || 'default model'}`;
      case 'expression':
        return 'JavaScript expression';
      case 'lookup':
        return 'Data lookup from external source';
      case 'customCode':
        return `Custom code: ${rule.config.function || 'unnamed function'}`;
      default:
        return 'Unknown rule type';
    }
  };

  const getRuleConfigSummary = (rule) => {
    switch (rule.type) {
      case 'prompt':
        return rule.config.prompt 
          ? `"${rule.config.prompt.substring(0, 50)}${rule.config.prompt.length > 50 ? '...' : ''}"` 
          : 'No prompt configured';
      case 'expression':
        return rule.config.expression 
          ? `"${rule.config.expression}"` 
          : 'No expression configured';
      case 'lookup':
        return rule.config.source 
          ? `Source: ${rule.config.source}` 
          : 'No source configured';
      case 'customCode':
        return rule.config.function 
          ? `Function: ${rule.config.function}` 
          : 'No function selected';
      default:
        return 'No configuration details';
    }
  };

  const getBadgeColor = (type) => {
    switch (type) {
      case 'prompt':
        return 'bg-blue-100 text-blue-800';
      case 'expression':
        return 'bg-green-100 text-green-800';
      case 'lookup':
        return 'bg-yellow-100 text-yellow-800';
      case 'customCode':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  return (
    <div className="space-y-4">
      {rules.map((rule) => (
        <div key={rule._id} className="card">
          <div className="flex justify-between items-start">
            <div>
              <div className="flex items-center gap-2 mb-2">
                <h3 className="font-medium text-lg">{rule.fieldName}</h3>
                <span className={`px-2 py-1 rounded-full text-xs font-medium ${getBadgeColor(rule.type)}`}>
                  {rule.type}
                </span>
              </div>
              <p className="text-sm text-gray-600 mb-2">{getRuleTypeDescription(rule)}</p>
              <p className="text-sm text-gray-800">{getRuleConfigSummary(rule)}</p>
              
              {rule.dependsOn && rule.dependsOn.length > 0 && (
                <div className="mt-3">
                  <span className="text-xs text-gray-500">Depends on:</span>
                  <div className="flex flex-wrap gap-1 mt-1">
                    {rule.dependsOn.map((dep) => (
                      <span
                        key={dep}
                        className="bg-gray-100 text-gray-800 text-xs px-2 py-0.5 rounded"
                      >
                        {dep}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            
            <div className="flex space-x-4">
              <button
                onClick={() => onEdit(rule)}
                className="text-blue-600 hover:text-blue-800 text-sm"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(rule._id)}
                className="text-red-600 hover:text-red-800 text-sm"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default RulesList;